/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The order to return feedback entries in by creation date of the underlying request. 'asc' returns oldest first, 'desc' returns newest first. Defaults to 'desc' (newest first).
 */
export const ListCompletionFeedbackQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * The order to return feedback entries in by creation date of the underlying request. 'asc' returns oldest first, 'desc' returns newest first. Defaults to 'desc' (newest first).
 */
export type ListCompletionFeedbackQueryParamOrder = ClosedEnum<
  typeof ListCompletionFeedbackQueryParamOrder
>;

/**
 * Only return feedback entries with this rating. Omit to return entries with any rating.
 */
export const QueryParamRating = {
  ThumbsUp: "thumbs_up",
  ThumbsDown: "thumbs_down",
} as const;
/**
 * Only return feedback entries with this rating. Omit to return entries with any rating.
 */
export type QueryParamRating = ClosedEnum<typeof QueryParamRating>;

export type ListCompletionFeedbackRequest = {
  after?: string | undefined;
  limit?: number | undefined;
  /**
   * The order to return feedback entries in by creation date of the underlying request. 'asc' returns oldest first, 'desc' returns newest first. Defaults to 'desc' (newest first).
   */
  order?: ListCompletionFeedbackQueryParamOrder | undefined;
  /**
   * Only return feedback entries with this rating. Omit to return entries with any rating.
   */
  rating?: QueryParamRating | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListCompletionFeedbackQueryParamOrder$inboundSchema:
  z.ZodNativeEnum<typeof ListCompletionFeedbackQueryParamOrder> = z.nativeEnum(
    ListCompletionFeedbackQueryParamOrder,
  );
/** @internal */
export const ListCompletionFeedbackQueryParamOrder$outboundSchema:
  z.ZodNativeEnum<typeof ListCompletionFeedbackQueryParamOrder> =
    ListCompletionFeedbackQueryParamOrder$inboundSchema;

/** @internal */
export const QueryParamRating$inboundSchema: z.ZodNativeEnum<
  typeof QueryParamRating
> = z.nativeEnum(QueryParamRating);
/** @internal */
export const QueryParamRating$outboundSchema: z.ZodNativeEnum<
  typeof QueryParamRating
> = QueryParamRating$inboundSchema;

/** @internal */
export const ListCompletionFeedbackRequest$inboundSchema: z.ZodType<
  ListCompletionFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListCompletionFeedbackQueryParamOrder$inboundSchema.default("desc"),
  rating: QueryParamRating$inboundSchema.optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListCompletionFeedbackRequest$Outbound = {
  after?: string | undefined;
  limit: number;
  order: string;
  rating?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListCompletionFeedbackRequest$outboundSchema: z.ZodType<
  ListCompletionFeedbackRequest$Outbound,
  z.ZodTypeDef,
  ListCompletionFeedbackRequest
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListCompletionFeedbackQueryParamOrder$outboundSchema.default("desc"),
  rating: QueryParamRating$outboundSchema.optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listCompletionFeedbackRequestToJSON(
  listCompletionFeedbackRequest: ListCompletionFeedbackRequest,
): string {
  return JSON.stringify(
    ListCompletionFeedbackRequest$outboundSchema.parse(
      listCompletionFeedbackRequest,
    ),
  );
}
export function listCompletionFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListCompletionFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListCompletionFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCompletionFeedbackRequest' from JSON`,
  );
}
